import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import RootfilesGridLayout from './containers/Grid';

export default function RootfileLayout() {
  return <Router>
    <PrivateRoute path="/cms/settings/rootfiles" component={RootfilesGridLayout} />
  </Router>;
}
